module.exports = __webpack_public_path__ + "static/img/8-Bruntwood-SciTech-partnership.e36f6bfa.jpg";